import { Link } from '@solidjs/router';
import { styled } from 'solid-styled-components';
import { fontFamilyAtosRegular, palette, theme } from '../../style/theme';

const { spacing } = theme;

export const StyledVideoWrapper = styled.div<{ adjustForHcpHeader: boolean }>`
    container-type: inline-size;
    margin: ${spacing.xl} 0;


    ${p => p.adjustForHcpHeader ? `
        ${theme.mediaQueries.desktopMin} {
            margin-top: 10rem;
        }
            
        margin-top: 8rem;
    ` : ''}
`;

export const StyledBreadCrumbsWrapper = styled.div`
    color: ${palette.gray};
    font-family: ${fontFamilyAtosRegular};
    font-size: 1.64rem;
    padding-top: 1rem;
    display: flex;
    gap: 0.5rem;
`;

export const StyledLink = styled(Link)`
    color: ${palette.gray};
    &:hover {
        color: ${theme.palette.pink};
    }
`;

export const StyledCurrentPage = styled.div`
    color: ${palette.red};
`;

export const VideoPostCardOuter = styled.div`
    display: flex;
    gap: 0.5rem;

    ${theme.mediaQueries.tabletMin} {
        width: 70%;
        margin: 0 auto;
    }

    ${theme.mediaQueries.mobileMax} {
        padding: ${spacing.s} ${spacing.xxs};
    }
`;

export const RelatedPostsOuter = styled.div`

    ${theme.mediaQueries.mobileMax} {
        padding: ${spacing.s} ${spacing.xxs};
    }
`;
